import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

// The exact records behind a goal actual (same shared actuals the widget uses — totals reconcile).
export function GoalActualDialog({ year, metric, progress, label, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/recruiting/goals/actuals", { params: { year, metric, district_org_id: progress.district_org_id || "", goal_scope: progress.goal_scope || "group",
      user_id: progress.goal_meta?.user_id || "" } }).then((r) => setData(r.data)).catch((e) => { toast.error(apiError(e)); setData({ items: [], total: 0 }); });
  }, [year, metric, progress]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-2xl" data-testid="goal-actual-dialog">
        <DialogHeader><DialogTitle>{label} — {year} actual ({data?.total ?? "…"})</DialogTitle>
          <DialogDescription>{data?.definition}</DialogDescription></DialogHeader>
        <div className="max-h-[55vh] overflow-auto">
          <table className="w-full text-sm"><thead className="text-xs text-slate-500"><tr>{["Person", "Date", "Recruiter", "Source"].map((h) => <th key={h} className="text-left px-2 py-1.5">{h}</th>)}</tr></thead>
            <tbody className="divide-y">{(data?.items || []).map((r, i) => (
              <tr key={`${r.pid}-${i}`} data-testid={`goal-actual-row-${i}`}>
                <td className="px-2 py-1.5"><Link to={`/people/detail/${r.pid}`} className="text-brand hover:underline">{r.name}</Link></td>
                <td className="px-2 py-1.5 whitespace-nowrap">{new Date(`${r.date}T12:00:00`).toLocaleDateString()}</td>
                <td className="px-2 py-1.5">{r.recruiter}</td><td className="px-2 py-1.5 text-slate-500">{r.source}</td>
              </tr>))}</tbody></table>
          {data && data.items.length === 0 && <p className="text-sm text-slate-400 py-6 text-center">No qualifying results yet this year.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
